import { createContext } from "../../../../hooks/createContext";

const [useCtx, Provider] = createContext<boolean>();

export const useAllRowsClosedContext = useCtx;
export const AllRowsClosedProvider = Provider;